import styled from "styled-components";
import { colors } from "../../../../../../consts";
import { WrapperContainer } from "../../../../../../components";
import { IconButtonStyled } from "../../../../../../components/Buttons/styled";

export const Circle = styled(WrapperContainer)`
  position: absolute;
  left: -5px;
  top: -2px;
  background: white;
  padding: 4px 0;

  &:before {
    content: "";
    display: block;
    width: 9px;
    height: 9px;
    min-height: 9px;
    min-width: 9px;

    box-sizing: border-box;

    border: 2px solid;
    border-color: ${colors.RAISIN_40};
    border-radius: 100%;
  }
`;

export const VersionSelectorContainer = styled(WrapperContainer)`
  position: relative;
  width: 100%;

  border-left: 2px dashed;
  border-color: ${colors.RAISIN_40};

  padding-left: 16px;
  padding-bottom: 16px;

  &:last-of-type {
    padding-bottom: unset;
    border-color: transparent;

    ${Circle} {
      &:before {
        background: ${colors.RAISIN_40};
      }
    }
  }
`;

export const DropdownInputWrapper = styled(WrapperContainer)`
  > ${IconButtonStyled} {
    margin-top: 18px;
  }
`;
